import { Box, styled } from '@material-ui/core';

export const Container = styled(Box)(({ theme }) => ({
  display: 'grid',
  gridTemplateColumns: 'repeat(auto-fit, minmax(231px, 1fr))',
  gridGap: theme.spacing(3),
  marginBottom: '12px'
}));

export const Item = styled(Box)(() => ({
  border: `1px solid  #e1e1e8`,
  borderRadius: 20,
  padding: '12px 16px',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  justifyContent: 'space-between',
  color: '#696974',
  backgroundColor: '#fff',
  minWidth: 231,
  height: 100
}));

export const IconContainer = styled(Box)({
  width: 40,
  height: 40,
  borderRadius: '50%',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  backgroundColor: '#F8F9FA',
  border: '1px solid #EEF0F2'
});

export const Content = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  gridGap: 5,
  marginLeft: 6,
  color: '#333D47'
});

export const TopContainer = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  flexDirection: 'row',
  gridGap: 5
});
